module.exports = __webpack_public_path__ + "static/media/Grand-Hotel.716ec7e4.svg";